import axios from 'axios'
// axios.defaults.baseURL = 'http://tmerp.local/wp-json/tmr/v1'
// process.env.NODE_ENVによって接続先を変更
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'
} else {
  axios.defaults.baseURL = 'http://tmerp.local/wp-json/tmr/v1'
}
// axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'
const state = {
  year: '',
  month: '',
  day: '',
  list: []
}
const getters = {
  year: (state) => state.year,
  month: (state) => state.month,
  day: (state) => state.day,
  list: (state) => state.list
}

const mutations = {
  year (state, year) {
    state.year = year
  },
  month (state, month) {
    state.month = month
  },
  day (state, day) {
    state.day = day
  },
  list (state, list) {
    state.list = list
  }
}
const actions = {
  async get ({ getters, commit }) {
    return new Promise((resolve) => {
      axios
        .get('/calendar/bracan/' + getters.year + '-' + ('0' + getters.month).slice(-2))
        .then((response) => {
          commit('list', response.data)
          // console.log('calendar loaded')
          console.log('calendar loaded', response.data)
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
        })
    })
  }
}

const Calendar = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default Calendar
